import { createSlice } from '@reduxjs/toolkit';

export const predictionSlice = createSlice({
  name: 'prediction',
  initialState: {
    groups: [],
    items: [],
    startDate: null,
    endDate: null,
    isLoading: false,
  },
  reducers: {
    startLoadingPreEvents: (state /* action */) => {
      state.isLoading = true;
    },
    endLoadingPreEvents: (state /* action */) => {
      state.isLoading = false;
    },
    setPreEventList: (state, { payload }) => {
      state.groups = payload.groups;
      state.items = payload.items;
      state.startDate = payload.startDate;
      state.endDate = payload.endDate;
      state.isLoading = false;
    },
  },
});

// Action creators are generated for each case reducer function
export const { startLoadingPreEvents, setPreEventList, endLoadingPreEvents } =
  predictionSlice.actions;
